import React, { useEffect, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import classes from "./cancelBooking.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import CancelBookingDone from "./CancelBookingDone";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";

const CancelBooking = ({ show, setShow }) => {
  const [cancelReason, setCancelReason] = useState();
  const [reason, setReason] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  const cancelArray = [
    "Medical emergency",
    "Weather",
    "Other (nothing from the above)",
  ];

  return (
    <div className={classes.modal}>
      <style jsx>{`
        @media screen and (max-width: 580px) {
          .modal .modal-dialog {
            max-width: 80% !important;
            margin: 0px 10%;
          }
        }
        .${modalClasses.body} {
          padding: 0px 24px 24px 24px !important;
        }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "16px 32px", margin: "0px" }}
        width={"509px"}
        header={
          <h4
            style={
              isMobile
                ? {
                    ...Fonts.h3,
                    fontSize: "24px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }
                : {
                    ...Fonts.h4,
                    fontSize: "26px",
                    color: Colors.neutralShadesOfNero,
                  }
            }
          >
            Cancel Booking
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <Button
              label={"Cancel"}
              primary={false}
              customStyle={{
                width: "95px",
                marginRight: "20px",
                backgroundColor: Colors.white,
                border: "none",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
            />
            <Button
              label={"Submit"}
              primary={true}
              customStyle={{
                width: "120px",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={() => {
                setConfirm(true);
                setShow(false);
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          {cancelArray?.map((item, i) => {
            return (
              <div className={[classes.mb16].join(" ")} key={i}>
                <Checkbox
                  label={`${item}`}
                  value={cancelReason}
                  setValue={setCancelReason}
                />
              </div>
            );
          })}

          <div>
            {cancelReason?.includes("Other (nothing from the above)") && (
              <TextArea
                placeholder={"Tell us more about why you can’t come..."}
                state={reason}
                setter={setReason}
              />
            )}
          </div>
          <div className={[classes.disclaimerSection].join(" ")}>
            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              className={classes.mt24}
            >
              <span style={{ ...Fonts.h7, color: Colors.errorColor }}>
                PLEASE NOTE!
              </span>{" "}
              Since less than 24 hours are left before the start of the lesson,{" "}
              <span style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}>
                we will not be able to refund the payment.
              </span>
            </p>
          </div>
        </div>
      </ModalSkeleton>
      <CancelBookingDone show={confirm} setShow={setConfirm} />
    </div>
  );
};
export default CancelBooking;
